import React from 'react';
import styled from 'styled-components';
import { colors } from '../utils/colors';
import { Races } from '../utils/races';

const StyledSelect = styled.select`
    width: 300px;
    min-height: 40px;
    border: 1px solid ${colors.primaryRedDark};
    border-radius: 2px;
    font-family: 'Titillium Web';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-top: 10px;
`;

export const RaceSelector = ({ selection, setSelection, multiple=false }) => {
    return (
        <div>
            <StyledSelect placeholder="Select Race" value={selection} onChange={(e) => {setSelection(e.target.value)}} multiple={multiple} >
                <option value="" disabled defaultValue hidden>Select Race</option>
                {Races.map((race) => (
                    <option key={race} value={race}>{race}</option>
                ))}
            </StyledSelect>
        </div>
    );
}